export default __webpack_public_path__ + "static/media/editIcon.f6a5c678.svg";